import React from 'react'
import ReactDOM from 'react-dom'
import App from 'app/site/app'

ReactDOM.render(
  <App />,
  document.getElementById('page-container')
)


// WEBPACK FOOTER //
// ./app/javascript/packs/site/app.js